import {
  authReducer,
  AuthState,
} from './auth/reducers/auth.reducers';
import {authFeatureKey} from './auth/auth.selectors';
import {contactFeatureKey} from './contact/contact.selectors';
import {contactReducer} from './contact/reducers/contact.reducers';
import {portalFeatureKey} from './portal/portal.selectors';
import {portalReducer} from './portal/reducers/portal.reducers';
import {ContactState} from './contact/contact.model';
import {PortalState} from './portal/portal.model';
import {sharedLinkReducer} from './shared-link/reducers/shared-link.reducer';
import {SharedLinkState} from './shared-link/shared-link.model';
import {sharedLinkFeatureKey} from './shared-link/shared-link.selectors';

export interface AppState {
  [authFeatureKey]: AuthState,
  [contactFeatureKey]: ContactState,
  [portalFeatureKey]: PortalState,
  [sharedLinkFeatureKey]: SharedLinkState
}

export const store = {
  [authFeatureKey]: authReducer,
  [contactFeatureKey]: contactReducer,
  [portalFeatureKey]: portalReducer,
  [sharedLinkFeatureKey]: sharedLinkReducer,
};
